import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import "../../css/main.css";
import AccountTreeIcon from '@mui/icons-material/AccountTree';

export default function WorkspaceInvitation({
                                                openWorkspaceInvitation,
                                                handleWorkspaceInvitationClose,
                                                handleInvitationAnswer,
                                                avoidMisfire,
                                                invitationSender,
                                                workspaceName
                                            }) {
    const { t } = useTranslation();

    return (
        <Dialog open={openWorkspaceInvitation} onClose={handleWorkspaceInvitationClose} className="modal-background-color">
            <DialogTitle>{t("modal.workspace_invite_title")}</DialogTitle>
            <DialogContent className="white-txt-color">
                <p>
                    {t("modal.invitation_message", { sender: invitationSender })}
                </p>
                <p>
                    <strong style={{color: "lightblue", display: "flex", justifyContent: "center"}}> <AccountTreeIcon style={{marginRight: "0.5rem"}}/>{workspaceName}</strong>
                </p>
                <p>
                    {t("modal.confirmation_question")}
                </p>
            </DialogContent>
            <DialogActions>

                <Button onClick={handleWorkspaceInvitationClose} className="decline-button">
                    <CancelIcon style={{ marginRight: 4 }} />
                    {t("global.cancel")}
                </Button>
                <Button onClick={handleInvitationAnswer} disabled={avoidMisfire} className="accept-button">
                    <CheckCircleIcon style={{ marginRight: 4 }} />
                    {t("notifications.accept")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
